import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";


export const UnpublishIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\uf236'}</MuiIcon>
    );
}
